import { styled, t } from '@aibi-ui/core';
import { AntdDropdown, AntdPagination } from 'src/components';
import Icons from '../../../components/Icons';
import { Tooltip } from '../../../components/Tooltip';
import { Menu } from '../../../components/Menu';
import TruncatedText from '../../../components/TruncatedText';

const ListViewStyled = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  border: 1px solid #d9e4f8;
  background: #fff;
  padding: 12px;
  .home-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    .home-list-header-left,
    .home-list-header-right {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .home-list-header-left {
      gap: 16px;
      .home-list-header-title {
        color: #2e405d;
        font-size: 16px;
        font-weight: 600;
      }
    }
    .home-list-header-right {
      justify-content: flex-end;
      .home-list-header-add {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 4px;
        margin-right: 12px;
        padding: 4px 16px;
        cursor: pointer;
        border: 1px solid #dcdcdc;
        border-radius: 3px;
        background: #fff;
        font-size: 14px;
        color: #3b4b67;
        transition: all 0.1s ease;
        &:hover {
          border-color: #5687ff;
          color: #5687ff;
        }
        svg {
          width: 16px;
          height: 16px;
        }
      }
      .home-list-header-more {
        display: flex;
        align-items: center;
        margin-right: 12px;
        color: #3b4b67;
        font-size: 14px;
        cursor: pointer;
        svg {
          width: 16px;
          height: 16px;
        }
      }
      .home-list-header-shift {
        display: flex;
        align-items: center;
        > div {
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: 24px;
          min-height: 24px;
          max-width: 24px;
          max-height: 24px;
          width: 24px;
          height: 24px;
          padding: 4px;
          border-radius: 4px;
          color: #3b4b67;
          cursor: pointer;
          svg {
            width: 16px;
            height: 16px;
            fill: none;
          }
          &:hover {
            background: rgba(86, 135, 255, 0.1);
            color: #5687ff;
          }
        }
      }
    }
  }
  .home-list {
    height: calc(100% - 47px);
    overflow: auto;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
`;

const TabsStyled = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  .tab {
    font-size: 14px;
    padding: 6px 8px;
    color: #909aaa;
    border-bottom: 2px solid transparent;
    transition: all 0.1s ease;
    cursor: pointer;
  }
  .active-tab {
    color: #5687ff;
    border-bottom: 2px solid #5687ff;
  }
`;
const Tabs = ({ activeTab, tabs, tabChange }) => {
  if (!tabs) return <></>;
  return (
    <TabsStyled>
      {tabs.map(tab => (
        <div
          className={`tab ${activeTab === tab.value ? 'active-tab' : ''}`}
          onClick={() => tabChange(tab.value)}
        >
          {tab.label}
        </div>
      ))}
    </TabsStyled>
  );
};

const ListStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 6px;
  color: #3b4b67;
  font-size: 15px;
  border-bottom: 1px solid #f5f6f8;
  width: 100%;
  .list-item-icon {
    margin-right: 4px;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    svg {
      width: 18px;
      height: 118px;
    }
  }
  .list-item-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
    width: calc(100% - 160px - 64px);
    svg {
      cursor: pointer;
      width: 14px;
      height: 14px;
      fill: none;
    }
  }
  .list-item-date {
    margin-left: auto;
    margin-right: 32px;
  }
  .list-item-detail {
    color: #5687ff;
    cursor: pointer;
  }
`;
const List = ({ list, onDetail, onFavorite }) => {
  if (list.length === 0) return <></>;
  return list.map((item, index) => (
    <ListStyled>
      {item.icon && <div className="list-item-icon">{item.icon}</div>}
      <div className="list-item-title">
        {(item.favorite === true || item.favorite === false) && (
          <>
            {item.favorite && (
              <Icons.FavoriteSelected
                viewBox="0 0 14 14"
                onClick={() => onFavorite(item, false)}
              />
            )}
            {!item.favorite && (
              <Icons.FavoriteUnselected
                viewBox="0 0 14 14"
                onClick={() => onFavorite(item, true)}
              />
            )}
          </>
        )}
        <TruncatedText text={item.title} lineClamp={1} />
      </div>
      <div className="list-item-date w-[20%] lg:w-fit">
        <TruncatedText text={item.date} lineClamp={1} />
      </div>
      <div className="list-item-detail" onClick={() => onDetail(item)}>
        查看
      </div>
    </ListStyled>
  ));
};

const CardStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  .card-list {
    overflow: auto;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    gap: 16px;
    height: calc(100% - 24px);
    &::-webkit-scrollbar {
      display: none;
    }
    .list-card-item {
      padding: 10px 8px;
      width: 250px;
      height: 122px;
      background: #f8f8fa;
      border-radius: 6px;
      .list-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .list-card-header-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: calc(100% - 30px);
          svg {
            width: 14px;
            height: 14px;
            cursor: pointer;
            fill: none;
          }
          .list-chart-header-icon {
            min-width: 32px;
            min-height: 32px;
            width: 32px;
            height: 32px;
            margin-right: 4px;
            border-radius: 4px;
            svg {
               width: 24px;
               height: 24px;
            }
          }
          .list-card-header-title {
            color: #2e405d;
            font-size: 15px;
            width: 100%;
            cursor: pointer;
            padding-left: 4px;
          }
        }
        .list-card-header-right {
          .card-actions {
          }
        }
      }
      .list-card-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 40px;
        padding-top: 12px;
        border-top: 1px solid #dcdcdc;
        .list-card-footer-date {
          font-size: 12px;
          color: #3b4b67;
        }
        .list-card-footer-status {
          padding: 2px 8px;
          border-radius: 6px;
          background: #fff;
        }
      }
    }
  }
  .ant-pagination {
    display: flex;
    align-items: center;
    .ant-pagination-prev,
    .ant-pagination-next {
      display: flex;
      justify-content: center;
      align-items: center;
      .ant-pagination-item-link {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .ant-pagination-item {
      color: #909aaa;
      font-size: 12px;
      border-radius: 4px;
      border: none;
      &:hover {
        a {
          color: #3b4b67;
        }
      }
    }
    .ant-pagination-item-active {
      background: #f8f8fa;
      border: none;
      a {
        color: #3b4b67;
      }
    }
  }
`;
const Card = ({
  current,
  onPageChange,
  pageSize,
  total,
  list,
  onDetail,
  onFavorite,
  actions,
  onAction,
}) => (
  <CardStyled>
    <div className="card-list">
      {list &&
        list.length > 0 &&
        list.map((item, index) => (
          <div className="list-card-item">
            <div className="list-card-header">
              <div className="list-card-header-left">
                {item.icon && (
                  <div className="list-chart-header-icon">{item.icon}</div>
                )}
                {(item.favorite === true || item.favorite === false) && (
                  <>
                    {item.favorite && (
                      <Icons.FavoriteSelected
                        viewBox="0 0 14 14"
                        onClick={() => onFavorite(item, false)}
                      />
                    )}
                    {!item.favorite && (
                      <Icons.FavoriteUnselected
                        viewBox="0 0 14 14"
                        onClick={() => onFavorite(item, true)}
                      />
                    )}
                  </>
                )}
                <TruncatedText
                  text={item.title}
                  lineClamp={1}
                  textClassName="list-card-header-title"
                  onClick={() => onDetail(item)}
                />
              </div>
              <div className="list-card-header-right">
                {actions && (
                  <AntdDropdown
                    overlay={
                      <Menu onClick={({ key }) => onAction(item, key)}>
                        {actions.map(action => (
                          <Menu.Item key={action}>{action}</Menu.Item>
                        ))}
                      </Menu>
                    }
                  >
                    <div className="card-actions">
                      <Icons.ChatActions viewBox="0 0 16 16" />
                    </div>
                  </AntdDropdown>
                )}
              </div>
            </div>
            <div className="list-card-footer">
              <div className="list-card-footer-date">{item.date}</div>
              {item.status && (
                <div className="list-card-footer-status">{t(item.status)}</div>
              )}
            </div>
          </div>
        ))}
    </div>
    {current && (
      <AntdPagination
        size="small"
        current={current}
        onChange={onPageChange}
        defaultPageSize={pageSize}
        total={total}
        showSizeChanger={false}
      />
    )}
  </CardStyled>
);

const ListView = ({
  title,
  activeTab,
  tabs,
  tabChange,
  addText,
  onAdd,
  moreText,
  onMore,
  onDetail,
  onFavorite,
  list,
  type,
  onTypeChange,
  current,
  pageSize,
  total,
  onPageChange,
  actions,
  onAction,
}) => (
  <ListViewStyled>
    <div className="home-list-header">
      <div className="home-list-header-left">
        <div className="home-list-header-title">{title}</div>
        <Tabs activeTab={activeTab} tabChange={tabChange} tabs={tabs} />
      </div>
      <div className="home-list-header-right">
        {addText && (
          <div className="home-list-header-add" onClick={onAdd}>
            <Icons.Add viewBox="0 0 16 17" />
            {addText}
          </div>
        )}
        {moreText && (
          <div className="home-list-header-more" onClick={onMore}>
            <span>{moreText}</span>
            <Icons.DetailArrow viewBox="0 0 16 17" />
          </div>
        )}
        <div className="home-list-header-shift">
          <Tooltip title="卡片">
            <div onClick={() => onTypeChange('card')}>
              <Icons.ListCard viewBox="0 0 16 17" />
            </div>
          </Tooltip>
          <Tooltip title="列表">
            <div onClick={() => onTypeChange('list')}>
              <Icons.ListTable viewBox="0 0 16 17" />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
    <div className="home-list">
      {type === 'list' && (
        <List list={list} onDetail={onDetail} onFavorite={onFavorite} />
      )}
      {type === 'card' && (
        <Card
          current={current}
          pageSize={pageSize}
          total={total}
          onPageChange={onPageChange}
          list={list}
          onDetail={onDetail}
          onFavorite={onFavorite}
          actions={actions}
          onAction={onAction}
        />
      )}
    </div>
  </ListViewStyled>
);

export default ListView;
